import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Message } from 'primereact/message';

import { useSelector } from 'react-redux';

import { Dropdown } from 'primereact/dropdown';
import { updateCompanySettingsAsyncThunk } from '../../../store/modules/moduleSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { clearAllLuca } from '../../../store/modules/lucaSlice';

import { convertZirveNovaResponseToLucaFormat, getCompanyForDropdown, getZirveNovaCompanyInfo, getCompanyTitle } from './utils/util';
import { getAllWebServicesByModuleId } from '../../../service/request/moduleRequest';
import { portalDefterCheck } from '../datasoft/utils/DatasoftRequest';
import { loginZirveNova } from './utils/zirveNovaRequest';
import { deleteCompanyIsHere } from './utils/util';
import { getCompaniesByUserAsyncThunk } from '../../../store/company/userCompanySlice';

export default function ZirveNovaPage() {
    const { selectedProgram, selectedCompanyId, module, selectedCompany: selectedCompanySlice } = useSelector((state) => state.modules);

    const [response, setResponse] = useState(null);
    const [zirveNovaRawData, setZirveNovaRawData] = useState(null);
    const [companyList, setCompanyList] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [isLoginZirveNova, setIsLoginZirveNova] = useState(false);
    const [loginError, setLoginError] = useState(null);

    const [loading, setLoading] = useState(false);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [webServicesList, setWebServicesList] = useState(null);

    const [token, setToken] = useState(null);

    const [zirveNovaCompanies, setZirveNovaCompanies] = useState([]);
    const [selectedWebService, setSelectedWebService] = useState(null);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [pending, setPending] = useState(false);
    const [taxId, setTaxId] = useState('');
    const [eDefterSubeAdi, setEDefterSubeAdi] = useState('');
    const [eDefterSubeKodu, setEDefterSubeKodu] = useState('');

    // Program requirements states
    const [programUsername, setProgramUsername] = useState('');
    const [programPassword, setProgramPassword] = useState('');
    const [showPassword, setShowPassword] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toast = useRef(null);

    useEffect(() => {
        if (loginError) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: loginError, life: 3000 });

            setTimeout(() => {
                setLoginError(null);
            }, 3000);
        }
    }, [loginError]);

    const getWebServices = async () => {
        const res = await getAllWebServicesByModuleId(module?.id);
        setWebServicesList(res.data.data);
        setLoading(false);
    };

    useEffect(() => {
        if (module) {
            getWebServices();
        }
    }, [dispatch]);

    const login = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await loginZirveNova(programUsername, programPassword);
            setToken(res.data.data.access_token);

            const rawData = res.data.data.firma_list;
            const convertedData = convertZirveNovaResponseToLucaFormat(rawData);

            setZirveNovaRawData(rawData);
            setResponse(convertedData);
            setCompanyList(deleteCompanyIsHere(getCompanyForDropdown(convertedData), zirveNovaCompanies));
            setIsLoginZirveNova(true);

            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Giriş başarılı', life: 3000 });
            }, 1);

            getWebServices();
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        }
        setLoading(false);
    };

    const handleChangeCompany = async (e) => {
        setSelectedCompany(e.value);

        // ZirveNova'da şirket seçildiğinde otomatik olarak company bilgilerini al
        if (zirveNovaRawData) {
            const zirveNovaCompanyInfo = getZirveNovaCompanyInfo(zirveNovaRawData, e.value);
            // Burada vergi numarası veya diğer bilgiler varsa set edebiliriz
        }
    };

    const save = async () => {
        const data = {
            moduleId: module.id,
            companyId: selectedCompanyId,
            settings: {
                moduleId: module.id,
                title: module.title,
                program: {
                    _id: selectedProgram.id,
                    title: selectedProgram.title,
                    requirements: [
                        {
                            username: programUsername,
                            password: programPassword
                        }
                    ],
                    zirveNovaCompanies: zirveNovaCompanies
                }
            }
        };

        setPending(true);
        await dispatch(updateCompanySettingsAsyncThunk(data));
        await dispatch(getCompaniesByUserAsyncThunk());
        toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Şirket Güncellendi', life: 1500 });

        setTimeout(() => {
            window.location.reload();
        }, 1500);
    };

    const handleCreateCompany = () => {
        const company = response.find((item) => item.company.value === selectedCompany);
        const webServiceRequirements = webServicesList.find((item) => item.id === selectedWebService);

        // ZirveNova raw data'sından company bilgilerini al
        const zirveNovaCompanyInfo = getZirveNovaCompanyInfo(zirveNovaRawData, selectedCompany);

        const data = {
            companyName: company.company.label,
            companyCode: company.company.value,
            taxId: taxId,
            eDefterSubeAdi: eDefterSubeAdi,
            eDefterSubeKodu: eDefterSubeKodu,
            webService: {
                _id: webServiceRequirements.id,
                title: webServiceRequirements.title,
                url: webServiceRequirements.url,
                requirements: {
                    username: username,
                    password: password
                }
            }
        };

        setZirveNovaCompanies([...zirveNovaCompanies, data]);

        setTimeout(() => {
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Şirket Eklendi', life: 1500 });
        }, 100);
        setCompanyList(companyList.filter((item) => item.value !== selectedCompany));
        setDialogVisible(false);
        setSelectedCompany(null);
        setUsername('');
        setPassword('');
        setSelectedWebService(null);
        setTaxId('');
        setEDefterSubeAdi('');
        setEDefterSubeKodu('');
        dispatch(clearAllLuca());
    };

    const handleCheckPortal = async () => {
        const webService = webServicesList.find((item) => item.id === selectedWebService);

        const data = {
            url: webService.url,
            username: username,
            password: password
        };

        const res = await portalDefterCheck(data);

        if (res.data.success) {
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Web servis kullanıcı bilgileriniz doğrudur', life: 3000 });
        } else {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Web servis kullanıcı bilgileriniz hatalıdır', life: 3000 });
        }
    };

    const handleDeleteCompany = (rowData) => {
        setZirveNovaCompanies(zirveNovaCompanies.filter((item) => item.companyCode !== rowData.companyCode));
        setCompanyList([...companyList, { title: rowData.companyName, value: rowData.companyCode }]);
        setTimeout(() => {
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Şirket Silindi', life: 1500 });
        }, 100);
    };

    const checkCreate = () => {
        return selectedCompany && username && password && selectedWebService;
    };

    const dialogFooterTemplate = () => {
        return <Button label="Oluştur" icon="pi pi-check" className="p-button-info mt-3" onClick={() => handleCreateCompany()} disabled={!checkCreate()} />;
    };

    const actionCodeTemplate = (rowData) => {
        return <Button icon="pi pi-trash" tooltip="Sil" tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }} className="mx-2" rounded outlined severity="danger" onClick={() => handleDeleteCompany(rowData)} />;
    };

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <h4 className="m-0">Şirketler</h4>
            <div>
                <Button label="Şirket Ekle" icon="pi pi-plus-circle" className="p-button-primary text-white mr-4 mb-0" onClick={() => handleDialogOpen()} disabled={!isLoginZirveNova} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Ara..." />
                </span>
            </div>
        </div>
    );

    const handleDialogClose = () => {
        setDialogVisible(false);
        setSelectedCompany(null);
        setUsername('');
        setPassword('');
        setSelectedWebService(null);
        setTaxId('');
        setEDefterSubeAdi('');
        setEDefterSubeKodu('');
        dispatch(clearAllLuca());
    };

    const handleDialogOpen = () => {
        setSelectedCompany(null);
        setUsername('');
        setPassword('');
        setSelectedWebService(null);
        setTaxId('');
        setEDefterSubeAdi('');
        setEDefterSubeKodu('');
        dispatch(clearAllLuca());
        setDialogVisible(true);
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center">
                <Button className="" icon="pi pi-building" />
                <h3 className="mb-4 ml-3">{selectedCompanySlice?.name}</h3>
            </div>
            <div className="card">
                <div className="">
                    <div className="flex flex-column md:flex-row">
                        <div className="w-full">
                            <form className="" onSubmit={login}>
                                <h3>{selectedProgram?.title}</h3>
                                <div className="flex">
                                    <div className="py-3 flex-1 mr-4">
                                        <div className="w-full mb-2">
                                            <label htmlFor="username">Kullanıcı Adı</label>
                                        </div>
                                        <div className="w-full">
                                            <InputText type="text" onChange={(e) => setProgramUsername(e.target.value)} placeholder="Kullanıcı Adı" value={programUsername} className="w-full" />
                                        </div>
                                    </div>
                                    <div className="py-3 flex-1 mr-4">
                                        <div className="w-full mb-2">
                                            <label htmlFor="password">Şifre</label>
                                        </div>
                                        <div className="w-full relative">
                                            <InputText type={showPassword ? 'password' : 'text'} onChange={(e) => setProgramPassword(e.target.value)} placeholder="Şifre" value={programPassword} className="w-full" />
                                            <Button type="button" className="p-button-text p-button-sm p-0 ml-2 absolute right-0 top-0 h-full" icon={showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'} onClick={() => setShowPassword(!showPassword)} />
                                        </div>
                                    </div>
                                </div>
                                {!isLoginZirveNova ? <Message className="py-3 my-3" severity="warn" text="Şirketleri görüntülemek için giriş yapınız." /> : <Message className="py-3 my-3" severity="success" text="Şirketleri oluşturabilirsiniz." />}
                                <div className="w-full">
                                    <Button label="Giriş Yap" icon="pi pi-check" className="p-button-success text-white p-mr-2 mt-3" loading={loading} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Dialog header="Şirket Ekle" visible={dialogVisible} style={{ width: '50vw' }} maximizable modal onHide={() => handleDialogClose()} footer={dialogFooterTemplate}>
                    <div className="mt-4">
                        {isLoginZirveNova && (
                            <>
                                <label className="mb-2 block">Şirketler</label>
                                <Dropdown dataKey="_id" value={selectedCompany} onChange={handleChangeCompany} options={companyList} optionLabel="title" placeholder="Şirket Seçiniz" filter className="w-full mb-4" emptyMessage="Şirket Bulunamadı" />
                            </>
                        )}

                        {selectedCompany && (
                            <>
                                <div className="mb-4">
                                    <label className="mb-2 block">Vergi Numarası</label>
                                    <InputText value={taxId} onChange={(e) => setTaxId(e.target.value)} className="w-full" placeholder="Vergi numarasını giriniz" />
                                </div>
                                <div className="mb-4">
                                    <label className="mb-2 block">E Defter Şube Adı</label>
                                    <InputText value={eDefterSubeAdi} onChange={(e) => setEDefterSubeAdi(e.target.value)} className="w-full" placeholder="E Defter Şube Adı" />
                                </div>
                                <div className="mb-4">
                                    <label className="mb-2 block">E Defter Şube Kodu</label>
                                    <InputText
                                        value={eDefterSubeKodu}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 4) {
                                                setEDefterSubeKodu(e.target.value);
                                            }
                                        }}
                                        className={`w-full ${eDefterSubeKodu.length > 0 && eDefterSubeKodu.length < 4 ? 'p-invalid' : ''}`}
                                        placeholder="E Defter Şube Kodu (4 haneli)"
                                        maxLength={4}
                                    />
                                    {eDefterSubeKodu.length > 0 && eDefterSubeKodu.length < 4 && <small className="p-error">E Defter Şube Kodu 4 haneli olmalıdır.</small>}
                                </div>
                            </>
                        )}

                        <div>
                            <div className="w-full mb-2">
                                <label>Web Servis Programları</label>
                            </div>
                            <div>
                                <Dropdown
                                    dataKey="id"
                                    value={selectedWebService}
                                    onChange={(e) => setSelectedWebService(e.value)}
                                    options={webServicesList?.map((item) => ({ value: item.id, label: item.title })) || []}
                                    optionLabel="label"
                                    placeholder="Web Servis Seçiniz"
                                    filter
                                    className="w-full mb-3"
                                    emptyMessage="Web Servis Bulunamadı"
                                />
                            </div>
                        </div>
                        {selectedWebService && (
                            <div className="my-2">
                                <div className="w-full mb-2">
                                    <label>Web Servis Kullanıcı Adı</label>
                                </div>
                                <div className="w-full">
                                    <InputText className="w-full mb-4" type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Kullanıcı Adı" required />
                                </div>
                                <div className="w-full mb-2">
                                    <label>Web Servis Şifre</label>
                                </div>
                                <div className="flex w-full align-items-center gap-3">
                                    <InputText className="w-full" type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Şifre" required />
                                    <Button label="Şifreyi Kontrol Et" className="flex-shrink-0" onClick={handleCheckPortal} />
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>

                {zirveNovaCompanies && isLoginZirveNova && (
                    <DataTable
                        value={zirveNovaCompanies}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="{totalRecords} şirketten {first} ila {last} arası gösteriliyor"
                        emptyMessage="Şirket Bulunamadı"
                        className="my-6"
                        header={header}
                        globalFilter={globalFilter}
                    >
                        <Column field="companyName" header="Şirket İsmi" sortable style={{ minWidth: '12rem' }}></Column>
                        <Column header="İşlemler" body={actionCodeTemplate} exportable={false} style={{ minWidth: '12rem' }}></Column>
                    </DataTable>
                )}

                {zirveNovaCompanies.length > 0 && (
                    <div className="text-center mt-5">
                        <Button label="Kaydet" icon="pi pi-check" className="p-button-success text-white p-mr-2 px-6" onClick={() => save()} loading={pending} />
                    </div>
                )}
            </div>
        </>
    );
}
